<template>
  <b-skeleton
    :active="active"
    :circle="circle"
    :rounded="rounded"
    :size="size"
    :width="width"
    :height="height"
    :count="count"
    :position="position"
  />
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true,
    COMPONENT_ASYNC: false
  },
  name: 'SkeletonView',
  props: {
    active: {
      type: Boolean,
      default: true
    },
    circle: {
      type: Boolean
    },
    rounded: {
      type: Boolean
    },
    size: {
      type: String
    },
    width: {
      type: [String, Number]
    },
    height: {
      type: [String, Number]
    },
    count: {
      type: Number,
      default: 1
    },
    position: {
      type: String
    }
  }
};
</script>
